import { render, staticRenderFns } from "./KitchenReport.vue?vue&type=template&id=895ebb88&scoped=true&"
import script from "./KitchenReport.vue?vue&type=script&lang=ts&"
export * from "./KitchenReport.vue?vue&type=script&lang=ts&"
import style0 from "./KitchenReport.vue?vue&type=style&index=0&id=895ebb88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895ebb88",
  null
  
)

export default component.exports